import Types from "./types";
import { CarService } from "../../../service/car-service";

const fetchDataSuccess = data => ({
    type: Types.FETCH_DATA_SUCCESS,
    data
});

const fetchDataFailure = error => ({
    type: Types.FETCH_DATA_FAILURE,
    error
});

const fetchData = () => dispatch => {
    return CarService.fetchKMList()
        .then(response => {
            dispatch(fetchDataSuccess(response));
        })
        .catch(error => {
            dispatch(fetchDataFailure(error));
        });
};

const updateAPIStatus = (data) => ({
    type: Types.UPDATE_API_STATUS,
    data
});

const updateWhatsappStatus = (whatsappStatus) => ({
    type: Types.UPDATE_WHATSAPP_STATUS,
    whatsappStatus
});

export {
    fetchData,
    updateAPIStatus,
    updateWhatsappStatus
};
